// Module
var code = "<div class=\"{{class}}\" id=\"{{id}}\"> <script src=\"https://accounts.google.com/gsi/client\" async defer=\"defer\"></script> <div class=\"btn-google\"></div> </div>";
// Exports
module.exports = code;